import { useContext } from "react";
import {
  FormattedData,
  FormattedResource,
  PublishContext,
  PublishDispatchContext,
} from "./PublishContext";

export const usePublishModal = () => {
  const publishState = useContext(PublishContext);
  const setPublishState = useContext(PublishDispatchContext);

  if (publishState === null || setPublishState === null) {
    throw new Error("Cannot use publish context outside of provider");
  }

  const setQuery = (query: string) =>
    setPublishState((prev) =>
      prev.query !== query ? { ...prev, query } : prev
    );
  const setPageNum = (pageNum: number) =>
    setPublishState((prev) => ({ ...prev, pageNum }));
  const setFormattedData = (formattedData: FormattedData) =>
    setPublishState((prev) => ({ ...prev, formattedData }));
  const setSelectedResource = (selectedResource: FormattedResource | null) =>
    setPublishState((prev) => ({ ...prev, selectedResource }));

  return {
    ...publishState,
    setPublishState,
    setQuery,
    setPageNum,
    setFormattedData,
    setSelectedResource,
  };
};
